import Helmet from '../../components/Helmet'
import ErrorScreen from '../../components/ErrorScreen'

const NoMatch = () => {
  return (
    <>
      <Helmet title='Page Not Found' />
      <ErrorScreen
        title='PAGE NOT FOUND'
        message='The link you followed may be broken, or the page may have been removed.'
      />
    </>
  )
}

export default NoMatch
